import { optAction, optReaction } from "./lib";
import {
  ACTION_CLEAR_PREVIOUS_STATE,
  submitPickupBranchesAction,
  SET_SELECTED_BRANCHES_MAP,
} from "../../constants/actions";
import { action, payload } from "ts-action";
import { REVERT, COMMIT } from "redux-optimistic-ui";
import { IToggleOrderingServices } from "../../axios/toggleOrderingServices";

export const submitPickupBranches = optAction(
  submitPickupBranchesAction.requested,
  payload<IToggleOrderingServices>()
);
export const clearPreviousState = action(ACTION_CLEAR_PREVIOUS_STATE);
export const submitPickupBranchesSuccess = optReaction(
  submitPickupBranchesAction.fulfilled,
  payload<IToggleOrderingServices>(),
  COMMIT
);
export const submitPickupBranchesFailure = optReaction(
  submitPickupBranchesAction.rejected,
  payload<IToggleOrderingServices>(),
  REVERT
);

export interface ISelectedBranchesMap {
  pickup_branch_ids: Record<string, boolean>;
  delivery_branch_ids: Record<string, boolean>;
  drive_thru_branch_ids?: Record<string, boolean>;
}

export const setSelectedBranchesMap = action(
  SET_SELECTED_BRANCHES_MAP,
  payload<ISelectedBranchesMap>()
);
